var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.more)?_c('div',_vm._l((_vm.balance.filter(x => x.balance !== 0)),function(b){return _c('div',{key:`${b.categoryId}_${b.currency}`,staticClass:"d-flex my-1 balance justify-content-between"},[_c('CategoryInfo',{staticClass:"font-weight-bold mr-2",attrs:{"category-id":b.categoryId}}),_c('div',{staticClass:"money-font text-nowrap",class:{
        red: b.balance < 0,
        blue: b.balance > 0
      }},[(b.balance > 0)?_c('span',[_vm._v("+ ")]):_vm._e(),_vm._v(_vm._s(_vm.formatMoney(b.balance, b.currency))+" ")])],1)}),0):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }